import { render, staticRenderFns } from "./WsAppHeaderButton.vue?vue&type=template&id=336b5586&"
import script from "./WsAppHeaderButton.vue?vue&type=script&lang=js&"
export * from "./WsAppHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports